import { useQuery } from '@tanstack/react-query';
import { Empty } from 'antd';

import Panel from '@/components/Panel';
import SocialDisclosureBanner from '@/components/SocialDisclosureBanner';
import SocialRiskPanel from '@/components/SocialRiskPanel';
import { api } from '@/lib/api';
import {
  SOCIAL_RISK_EMPTY_TEXT,
  SOCIAL_RISK_ENDPOINT,
  type WeeklySocialRiskResponse,
} from '@/lib/socialRisk';
import { useWeekStore } from '@/stores/weekStore';

/**
 * /social-risk — REDFOX 社交传播风险（PR3-C-2，authenticated 非 admin）。
 * 消费 PR3-C-1 social-risk 读 API（端点见 SOCIAL_RISK_ENDPOINT）；独立面板，0 进 VOC/NPS·高管报告·Agent·看板。
 */
export default function SocialRiskPage() {
  const { week } = useWeekStore();
  const { data, isLoading } = useQuery({
    queryKey: ['social-risk', week],
    // M1：path 不带 /api/v2（shared client baseURL 已含），防双前缀
    queryFn: async () =>
      (await api.get<WeeklySocialRiskResponse>(SOCIAL_RISK_ENDPOINT, { params: { week } })).data,
  });
  const rows = data?.rows ?? [];

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-[17px] lg:text-[20px] font-semibold text-slate-900 m-0">
          社交传播风险 · {week}
        </h1>
        <p className="text-[12px] lg:text-[13px] text-slate-500 mt-1 mb-0">
          REDFOX 社交热度/传播信号（采样、非全网全量、未验证情绪、不计入 VOC/NPS）。本周帖数为
          mapped stored post（库内去重存储数，≠ 全网覆盖、≠ run-level after_dedupe）。
        </p>
      </div>

      {/* disclosure 显著置顶——B1 空态时仍渲 */}
      <SocialDisclosureBanner source={data ? { disclosure: data.disclosure } : null} />

      <Panel title="brand-week 社交传播风险">
        {!isLoading && rows.length === 0 ? (
          // B1 响应级空态（aggregate 未物化）：区别于 row 级 no_run/insufficient；非 0/绿/空白
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={SOCIAL_RISK_EMPTY_TEXT} />
        ) : (
          <SocialRiskPanel rows={rows} />
        )}
      </Panel>
    </div>
  );
}
